export const emailRules = [
  v => !!v || "Email is required",
  v => /.+@.+/.test(v) || "E-mail must be valid"
];

export const passwordRules = [
  v => !!v || "Password is required"
];

export const inputRules = [
  v => !!v || "This field is required"
];

export default {
  emailRules: emailRules,
  passwordRules: passwordRules
};
